export const firebaseConfig = {
    "projectId": "guidde-dev-staging",
    "appId": "1:824103114815:web:920ecf835920e36ead808a",
    "databaseURL": "https://guidde-dev-staging-default-rtdb.firebaseio.com",
    "storageBucket": "guidde-dev-staging.appspot.com",
    "locationId": "us-central",
    "apiKey": "AIzaSyAECvQGtSbTa6P0o69l-fGgrMp2xLAeKlY",
    "authDomain": "stg.guidde.com",
    "messagingSenderId": "824103114815",
    "measurementId": "G-HMRHP70X5B",
    "projectNumber": "824103114815",
    "version": "2",
    "stiggApiKey": "$2b$10$2tLiBrjgm05excoNtNqQS.PvzVTP.dnsM3fL/Jk77AeedV6moEpIO:0bd8f132-b309-46b2-b611-146a5c7a2d8f",
    "stiggEnv": "Staging",
    "environment": "staging"
}

export const BRAND_FETCH_CLIENT_KEY =
'1idDPkPufmX4E7kDhC0'
export const CHROMATIC_PROJECT_TOKEN =
'chpt_11a09a69edf99bb'
export const ENABLE_SAOLA =
'true'
export const GDRIVE_PICKED_API_KEY =
'AIzaSyBoUnV2XavthiNEO_rvlAfLAbZ6FAy2apY'
export const MIXPANEL_SESSION_REPLAY_PERCENT =
'10'
export const MIXPANEL_TOKEN =
'd287c9d57dcabe3765cd10c3da69b39e'
export const MS_CLIENT_ID =
'920bb2a3-6a38-48f6-af4f-47849df20d69'
export const SAOLA_ACCOUNT_TOKEN =
'856f10ef-4168-4be6-8d73-06030e21a9a0'
export const STIGG_API_KEY =
'$2b$10$2tLiBrjgm05excoNtNqQS.PvzVTP.dnsM3fL/Jk77AeedV6moEpIO:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_BASE_URL =
'https://stg.guidde.com/stigg/api'
export const STIGG_CLIENT_KEY =
'$2b$10$2tLiBrjgm05excoNtNqQS.PvzVTP.dnsM3fL/Jk77AeedV6moEpIO:0bd8f132-b309-46b2-b611-146a5c7a2d8f'
export const STIGG_CLIENT_SDK_POLLING_INTERVAL_MS =
'10000'
export const STIGG_EDGE_URL =
'https://stg.guidde.com/stigg/api/edge'
export const STIGG_ENV =
'guidde-staging'
export const WEB_CLIENT_ID =
'824103114815-jbt3sku7g0nhhpndnbrh31f5g3qebun6.apps.googleusercontent.com'
export const entailApiKey =
'et-WJgibNJi14XN2kj8esMTq2ke_JhVpI8n5kq0lPv1-2eEnbIv'
export const isSeparateNetworkIssuesInMonitoring =
'true'
export const tapfiliateAccountId =
'47910-93439a'